module.exports = __webpack_public_path__ + "static/a-xx-176-art-5e71137ff6de7e8471b26ab3f9e24666.jpg";